import { createFileRoute } from "@tanstack/react-router";

import PasswordForm from "./-components/PasswordForm";

export const Route = createFileRoute("/_authenticated/settings/password")({
  component: PasswordForm,
});
